import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2 } from 'lucide-react';
import { useLanguage } from '../context/LanguageContext';
export const SolutionSection: React.FC = () => {
  const {
    t
  } = useLanguage();
  const solutions = [{
    image: 'https://images.unsplash.com/photo-1586717791821-3f44a563fa4c?w=120&h=120&fit=crop&q=80',
    title: t('solution.item.1.title'),
    desc: t('solution.item.1.desc')
  }, {
    image: 'https://images.unsplash.com/photo-1611606063065-ee7946f0787a?w=120&h=120&fit=crop&q=80',
    title: t('solution.item.2.title'),
    desc: t('solution.item.2.desc')
  }, {
    image: 'https://images.unsplash.com/photo-1554224155-6726b3ff858f?w=120&h=120&fit=crop&q=80',
    title: t('solution.item.3.title'),
    desc: t('solution.item.3.desc')
  }, {
    image: 'https://images.unsplash.com/photo-1450101499163-c8848c66ca85?w=120&h=120&fit=crop&q=80',
    title: t('solution.item.4.title'),
    desc: t('solution.item.4.desc')
  }];
  return <section className="py-24 bg-beige-100 relative overflow-hidden" data-id="element-130">
      <div className="absolute top-0 right-0 w-1/2 h-full bg-beige-50 rounded-l-[100px] opacity-50 -z-10" data-id="element-131"></div>

      <div className="container mx-auto px-6 max-w-5xl" data-id="element-132">
        <div className="flex flex-col lg:flex-row gap-16 items-center" data-id="element-133">
          <motion.div initial={{
          opacity: 0,
          x: -40
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.7
        }} className="lg:w-1/2" data-id="element-134">
            <h2 className="text-4xl md:text-5xl font-bold mb-6 leading-tight" data-id="element-135">
              {t('solution.title.1')}{' '}
              <span className="text-coral-500 italic" data-id="element-136">
                {t('solution.title.2')}
              </span>
            </h2>
            <p className="text-lg text-gray-700 font-sans mb-8 leading-relaxed" data-id="element-137">
              {t('solution.subtitle')}
            </p>

            <div className="space-y-6" data-id="element-138">
              {solutions.map((item, index) => <motion.div key={index} initial={{
              opacity: 0,
              y: 20
            }} whileInView={{
              opacity: 1,
              y: 0
            }} viewport={{
              once: true
            }} transition={{
              duration: 0.5,
              delay: 0.2 + index * 0.1
            }} className="flex items-start space-x-4" data-id="element-139">
                  <div className="w-12 h-12 rounded-xl shadow-sm border border-beige-200 mt-1 overflow-hidden flex-shrink-0" data-id="element-140">
                    <img src={item.image} alt={item.title} className="w-full h-full object-cover" data-id="element-141" />
                  </div>
                  <div data-id="element-142">
                    <h3 className="text-xl font-bold mb-1" data-id="element-143">{item.title}</h3>
                    <p className="text-gray-600 font-sans" data-id="element-144">{item.desc}</p>
                  </div>
                </motion.div>)}
            </div>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          scale: 0.9
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.7
        }} className="lg:w-1/2 relative" data-id="element-145">
            <div className="aspect-[4/5] bg-white rounded-3xl p-8 shadow-2xl border border-beige-200 flex flex-col justify-center items-center text-center relative overflow-hidden" data-id="element-146">
              <div className="absolute top-0 left-0 w-full h-2 bg-coral-500" data-id="element-147"></div>
              <h3 className="text-3xl font-bold mb-4" data-id="element-148">
                {t('solution.card.title')}
              </h3>
              <p className="font-sans text-gray-500 mb-8" data-id="element-149">
                {t('solution.card.subtitle')}
              </p>

              <div className="w-full space-y-3" data-id="element-150">
                {[{
                step: '01',
                label: t('solution.step.1')
              }, {
                step: '02',
                label: t('solution.step.2')
              }, {
                step: '03',
                label: t('solution.step.3')
              }, {
                step: '04',
                label: t('solution.step.4')
              }, {
                step: '05',
                label: t('solution.step.5')
              }, {
                step: '06',
                label: t('solution.step.6')
              }, {
                step: '07',
                label: t('solution.step.7')
              }, {
                step: '08',
                label: t('solution.step.8')
              }].map((item, i) => <div key={i} className="h-11 bg-beige-50 rounded-lg w-full flex items-center px-4 border border-beige-100" data-id="element-151">
                    <div className="w-6 h-6 rounded-full bg-coral-100 flex items-center justify-center mr-3 flex-shrink-0" data-id="element-152">
                      <CheckCircle2 className="w-4 h-4 text-coral-500" data-id="element-153" />
                    </div>
                    <span className="font-sans text-xs text-gray-400 mr-2" data-id="element-154">
                      {item.step}
                    </span>
                    <span className="font-sans text-sm font-medium text-dark" data-id="element-155">
                      {item.label}
                    </span>
                  </div>)}
              </div>
            </div>

            {/* Decorative elements */}
            <div className="absolute -bottom-6 -right-6 w-24 h-24 bg-coral-400 rounded-full opacity-20 blur-xl" data-id="element-156"></div>
            <div className="absolute -top-6 -left-6 w-32 h-32 bg-beige-200 rounded-full opacity-50 blur-xl" data-id="element-157"></div>
          </motion.div>
        </div>
      </div>
    </section>;
};